module.exports = __webpack_public_path__ + "img/left.595e3dd6.png";